import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage } from '@pages/LoginPage'
import { SignupPage } from '@pages/SignupPage'
import { PlatformConsole } from '@pages/PlatformConsole'
import { DashboardLayout } from '@layouts/DashboardLayout'
import { useAuthStore } from '@stores/authStore'

function App() {
  const { token, user } = useAuthStore()
  const home = user?.isPlatformAdmin ? '/admin' : '/dashboard'

  return (
    <Router>
      <Routes>
        <Route path="/login" element={token ? <Navigate to={home} /> : <LoginPage />} />
        <Route path="/admin/login" element={token ? <Navigate to={home} /> : <LoginPage admin />} />
        <Route path="/signup" element={token ? <Navigate to={home} /> : <SignupPage />} />

        {token ? (
          <>
            <Route path="/dashboard/*" element={<DashboardLayout />} />
            <Route path="/admin/*" element={user?.isPlatformAdmin ? <PlatformConsole /> : <Navigate to="/dashboard" />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}

        <Route path="*" element={<Navigate to={token ? home : '/login'} />} />
      </Routes>
    </Router>
  )
}

export default App
